import { useResponseHandler } from '@hooks/useResponseHandler';

import {
  useListAccessManagementUsersQuery,
  useListUsersAccessedByQuery,
} from 'generated/access-permission.generated';

export function useListUserAccessedByPermissions(user_id?: string | null) {
  const response = useListUsersAccessedByQuery({
    variables: { user_id: user_id ?? '' },
    skip: !user_id,
  });

  return {
    ...response,
    data: response.data?.getUserRecord.accessed_by ?? [],
  };
}

export function useListAccessManagementUsers(user_id?: string | null) {
  const { handleError } = useResponseHandler();
  const response = useListAccessManagementUsersQuery({
    variables: { user_id: user_id ?? '' },
    skip: !user_id,
  });
  handleError(response.error);

  const accountUsers = response.data?.getAccessManagement.account.users ?? [];
  const accessedByUsers = response.data?.getAccessManagement.accessed_by ?? [];

  const users = accessedByUsers.reduce<typeof accountUsers>(
    (acc, user) => {
      // Only add users that are not already in the list
      if (!acc.find((u) => u.user_id === user.user_id)) {
        acc.push(user);
      }
      return acc;
    },
    [...accountUsers]
  );

  return {
    ...response,
    data: users,
  };
}
